import React from "react";
import { Link } from "react-router-dom";
import MyFooter from "./my footer";
import "./About.css";
import Header from "./header";
import test from "./images/newgudoomiye.jpg"; // this will be the top image
import test2 from "./images/newgudoomiye.jpg";

function About() {
  return (
    <div className="main" >
      {/* ===== HEADER ===== */}
      <Header />

      {/* ===== TOP IMAGE ===== */}
      

      {/* ===== MAIN CONTENT ===== */}
      <div className="content">
        <div className="about-top-image">
        <img src={test} alt="E-Learning" />
        <img src={test} alt="E-Learning" />
      
      </div>
        <section className="about-section">
          {/* Text Right */}
          <div className="about-text">
            <h1>📚 About E-Learning</h1>
            <p>
              <b>UNIVERSITY OF SOMALIA (UNISO)</b> was founded by a group of
              dedicated Somali scholars and is committed to the development of
              human potential to contribute to the implementation of Somali
              national development plans. UNISO will serve the Somali nation by
              providing its students with world-class and relevant knowledge,
              skills, and ethical and moral training necessary for the 21st
              Century.
            </p>
            <p>
              It will strive to employ qualified, experienced and talented
              faculty capable and willing to provide UNISO students with the
              knowledge, insights, tools and techniques they need to realize
              their full potential and become productive Somali citizens.
            </p>
            <p>
              For over a decade, UNISO has been home to bright educators,
              aspiring students, and others who have been drawn from all over
              Somalia. We currently have the largest programs in health
              science, business administration and computer science in Mogadishu
              and we are striving to achieve national, regional and
              international recognition.
            </p>

            <h2>❓ Why E-learning</h2>
            <p>
              We offer over 35 different fully online and hybrid eLearning
              courses including Diploma, Bachelor and Master's. You can
              complete your first degree through convenient online classes.
              Each eLearning class is designed by the instructor who is
              teaching it, and the 'virtual classroom' closely blends with.
            </p>

            <h2>🌍 Vision Statement</h2>
            <p>
              eLearning inspires community engagement and inclusive learning
              environments through the use of emerging technologies.
            </p>

            <h2>🎯 Mission Statement</h2>
            <p>
              Our dynamic team serves the Center community by providing
              training, research, and flexible support services. Through
              creative problem solving, collaboration, and reflection we
              provide an environment for growth in teaching and learning in an
              effort to best support our students, faculty and staff.
            </p>

            <h2>💡 Our Values</h2>
            <ul>
              <li>Commitment</li>
              <li>Focus</li>
              <li>Openness</li>
              <li>Respect</li>
              <li>Courage</li>
              <li>Out-of-the-box thinking</li>
              <li>Passion</li>
            </ul>

            <h2>🤝 Our Commitments</h2>
            <p>
              <b>Leadership:</b> To lead in the development and delivery of
              innovative digital learning experiences.
            </p>
            <p>
              <b>E-Learning:</b> To build the capacity of teachers and system
              leaders for the purposeful integration of teaching and learning
              with technology.
            </p>
            <p>
              <b>Our Community:</b> To foster a digital community that engages
              everyone in continuous learning, communication and collaboration.
            </p>

            <h2>📈 Strategies</h2>
            <p>
              Leverage exemplary instructional design and instructional
              technologies to: create learner-centered instruction, improve
              and ensure course quality, enhance faculty effectiveness, and
              increase student success and retention.
            </p>
            <p>
              Partner with faculty, staff, and students, to showcase and
              advocate the effective application of innovative instructional
              technologies through sharing best practices.
            </p>
            <p>
              Advance the capabilities and adoption of the university’s
              enterprise course management system (Blackboard) to increase the
              effectiveness and efficiency of content delivery, assessment,
              and communication.
            </p>
          </div>
        </section>
      </div>

      {/* ===== FOOTER ===== */}
      <MyFooter />
    </div>
  );
}

export default About;
